import React, { Fragment, useEffect } from "react";
import COVIVID from "./assets/CoviHack Page assets/hack-o-relay-video.mp4";
import "./assets/css/CoviHack_Schedule.css";
import AOS from "aos";
import "aos/dist/aos.css";
const CoviHack_Schedule = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <Fragment>
      <div className="schedule mt-5 mb-5 ">
        <div className="container">
          <div className="row">
            <div className="greenbox"></div>
            <div className="col-md-6 d-flex justify-content-center">
              <video
                playsInline
                autoPlay
                loop
                muted
                id="covivid"
                data-aos="fade-right"
                className="mt-3 mb-3"
              >
                <source src={COVIVID} type="video/mp4" />
                your browser does not support tag.
              </video>
            </div>
            <div className="col-md-5 mt-4 " data-aos="fade-left">
              <h3 className="text-center mb-3">
                Schedule for <span>Hack-o-Relay</span>
              </h3>
              <hr />
              <div>
                <div>
                  <h5>26-05-2022 Thursday</h5>
                  <ul>
                    <h6>
                      <span>Introductory event</span>
                    </h6>

                    <li>
                      {" "}
                      Introductory event where we'll
                      discuss the rules of the Hackthon and release the Problem
                      Statements/themes of all three tracks{" "}
                    </li>
                    <li>
                      {" "}
                      Duration : 30-40 Mins
                    </li>
                    <li>
                      {" "}
                      Mode:   OFFLINE {" "}
                    </li>
                  </ul>
                  <ul>
                    <h6>
                      <span>Track 1 - Content Creation</span>
                    </h6>

                    <li>
                      {" "} Duration : 3hrs (2nd half) 
                    </li>
                    <li>
                      {" "}
                      Mode:<span> OFFLINE</span>{" "}
                    </li>
                  </ul>
                </div>
                <div>
                  <h5>27-05-2022 Friday</h5>
                  <ul>
                    <h6>
                      <span>Track 2 - Prototyping</span>
                    </h6>

                    <li>
                      {" "} Duration : 3hrs (2nd half)

                    </li>
                    <li>
                      {" "}
                      Mode: OFFLINE {" "}
                    </li>
                  </ul>
                  
                </div>
                <div>
                  <h5>28-05-2022 Saturday </h5>
                  <ul>
                    <h6>
                      <span>Track 3 - Development</span>
                    </h6>

                    <li>
                      {" "} Duration : 3hrs (2nd half)

                    </li>
                    <li>
                      {" "}
                      Mode: OFFLINE {" "}
                    </li>
                  </ul>
                  <ul>
                    <h6>
                      <span>Result Declaration</span>
                    </h6>

                    <li>
                      {" "} It will be declared on GDSC’S Youtube live stream where all the judges will be present with the teams.
                    </li>
                    <li>
                      {" "}
                      Mode: <span> ONLINE</span>{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CoviHack_Schedule;
